<template>
    <div class="EffectsWrapper ">
        <div class="text-uppercase font-bold text-xs tracking-wider mb-3 mt-4 text-gray-700">Effects</div>
        <div class="grid grid-cols-3 gap-1">
            <div class="cursor-pointer" @click="setEffect('none')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div>Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">none</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'shadow' ? 'active' : ''}`" @click="setEffect('shadow')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div
                        style="transform: translateZ(0px); text-shadow: rgba(86, 93, 100, 0.4) 1.27279px 1.27279px 0px;">
                        Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">shadow</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'lift' ? 'active' : ''}`" @click="setEffect('lift')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div style="transform: translateZ(0px); text-shadow: rgba(0, 0, 0, 0.4) 0px 1.2px 6px;">Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">lift</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'hollow' ? 'active' : ''}`" @click="setEffect('hollow')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div
                        style="transform: translateZ(0px); font-weight: 800; caret-color: rgb(86, 93, 100); -webkit-text-stroke: 1.488px rgb(86, 93, 100); -webkit-text-fill-color: transparent;">
                        Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">hollow</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'splice' ? 'active' : ''}`" @click="setEffect('splice')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div
                        style="transform: translateZ(0px); font-weight: 800; text-shadow: rgba(86, 93, 100, 0.5) 1.40856px 1.40856px 0px; caret-color: rgb(86, 93, 100); -webkit-text-stroke: 1.2px rgb(86, 93, 100); -webkit-text-fill-color: transparent;">
                        Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">splice</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'echo' ? 'active' : ''}`" @click="setEffect('echo')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div
                        style="transform: translateZ(0px); text-shadow: rgba(86, 93, 100, 0.5) 1.27279px 1.27279px 0px, rgba(86, 93, 100, 0.3) 2.54558px 2.54558px 0px;">
                        Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">echo</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'glitch' ? 'active' : ''}`" @click="setEffect('glitch')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div
                        style="transform: translateZ(0px); text-shadow: rgb(0, 255, 255) -0.72px 4.40873e-17px 0px, rgb(255, 0, 255) 0.72px -4.40873e-17px 0px;">
                        Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">glitch</div>
            </div>
            <div :class="`cursor-pointer boxing ${effectType === 'neon' ? 'active' : ''}`" @click="setEffect('neon')">
                <div class="border-transparent border-2 bg-gray-200 rounded-lg pt-2 pb-3 text-2xl text-center">
                    <div
                        style="filter: drop-shadow(rgba(103, 109, 116, 0.95) 0px 0px 0.552px) drop-shadow(rgba(86, 93, 100, 0.75) 0px 0px 2.736px) drop-shadow(rgba(86, 93, 100, 0.44) 0px 0px 8.04px); color: rgb(171, 174, 178); transform: translateZ(0px);">
                        Ab</div>
                </div>
                <div class=" mt-1 mb-3 capitalize text-center text-xs text-gray-700">neon</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "TextTab",
    data(){
        return {
            effectType:"none"
        }
    },
    watch:{
        "$store.state.activeObjectprops" : {
            handler(updatedValues) {
                
        
                console.log(updatedValues)
                this.effectType = updatedValues?.effectType?.type
            },
            deep: true,
            immediate: true

        },
    },
    methods:{
        setEffect(value){
            // this.effectType = value;
            if(value === "none"){
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: {type:value} });
            } else if(value === "shadow") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Shadow() });
            } else if(value === "lift") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Lift() });
            } else if(value === "hollow") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Hollow() });
            } else if(value === "splice") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.splice() });
            } else if(value === "echo") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.echo() });
            } else if(value === "glitch") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Glitch() });
            } else if(value === "neon") {
                this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Neon() });
            }
           
        },
        Shadow(){
            
            let obj = {
              type:"shadow",
              color:"",
              offset:"50",
              direction:"-45",
              blur:"0",
              transparency:"40"
            };
  
              return obj
          },
            Lift(){
            
            let obj = {
              type:"lift",
                intensity:"50"
            };
  
              return obj
          },
            Hollow(){
            
            let obj = {
              type:"hollow",
                thickness:"50"
            };
  
              return obj
          },
            splice(){
            
            let obj = {
              type:"splice",
              color:"",
              offset:"50",
              direction:"-45",
              thickness:"50",
            };
  
              return obj
          },
          echo(){
            
            let obj = {
                type:"echo",
                color:"",
            offset:"50",
            direction:"-45",
            };
  
              return obj
          },
          Glitch(){
            
            let obj = {
                type:"glitch",
                color:"",
                offset:"30",
                direction:"90",
            };
  
              return obj
          },
          Neon(){
            
            let obj = {
                type:"neon",
                intensity:"50"
            };
  
              return obj
          }
    }
}
</script>

<style scoped>
.boxing.active .border-transparent{
    border-color: #8e42ff !important;
    border-style: solid;

}
.text-gray-700 {
    color: rgb(73 80 87);
}

.tracking-wider {
    letter-spacing: .05em;
}

.text-xs {
    font-size: .75rem;
    line-height: 1rem;
}

.gap-1 {
    gap: .25rem;
}

.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid {
    display: grid;
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}

.bg-gray-200 {
    background-color: rgb(238 240 242);
}
.border-transparent {
    border-color: transparent;
}
.border-2 {
    border-width: 2px;
}
</style>